import * as tslib_1 from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
let SilentRenewView = class SilentRenewView extends Vue {
    constructor() {
        super();
    }
    mounted() {
        //console.log('Settings: ' + JSON.stringify(process.env.VUE_APP_OIDC_SETTINGS));
        //vuexOidcProcessSilentSignInCallback(process.env.VUE_APP_OIDC_SETTINGS);
    }
};
SilentRenewView = tslib_1.__decorate([
    Component({
        name: 'SilentRenew',
        components: {}
    })
], SilentRenewView);
export default SilentRenewView;
